<template>
  <div class="my-5 flex flex-col justify-between flex-1">
    <div class="flex justify-center px-4 items-center">
      <h1 class="text-3xl font-bold text-center">{{ __('Job :job conversation', {job: job.id}) }}</h1>
    </div>

    <chat class="my-5" :job="job" :conversation="conversation" :messages="messages"></chat>
  </div>
</template>

<script>
  import ClientJobLayout from "@/Shared/ClientJobLayout";
  import TextareaInput from "@/Shared/TextareaInput";
  import LoadingButton from "@/Shared/LoadingButton";
  import Chat from "../../Shared/Chat";

  export default {
    layout: ClientJobLayout,
    metaInfo() {
      return {
        title: this.__("Jobs")
      };
    },
    props: {
      job: Object,
      messages: Object,
      conversation: Object
    },
    components: {
      ClientJobLayout,
      TextareaInput,
      LoadingButton,
      Chat
    },
    created() {
      window.Echo.channel('App.Models.Client.' + this.job.client.id)
        .listen('MessageCreatedEvent', (data) => {
          if (
            data.device_client_id === sessionStorage.getItem('deviceClientId')
            && data.author_id == this.job.client.id
            && data.author_type === 'App\\Models\\Client'
          ) {
            return;
          }
          this.$inertia.reload({
            only: ['messages', 'auth'],
            preserveScroll: true
          });
        });
    }
  };
</script>
